import React from "react";
import { MAGICBI_LOGO_SRC } from "../../../constants/brandAssets";
import {
  Card,
  Header,
  HeaderIcon,
  IllustrationArea,
  Label,
  Preview,
  PreviewImage,
  PreviewSparkle,
} from "./AiStoryCreationCard.styles";
import type { AiStoryCreationCardProps } from "./AiStoryCreationCard.types";

export const AiStoryCreationCard: React.FC<AiStoryCreationCardProps> = ({
  label = "Create data story with AI",
  onSelect,
  disabled = false,
  selected,
  className,
}) => (
  <Card
    type="button"
    className={className}
    disabled={disabled}
    aria-pressed={selected}
    onClick={onSelect}
  >
    <Header>
      <HeaderIcon aria-hidden="true">
        <img src={MAGICBI_LOGO_SRC} alt="MagicBI" width={16} height={16} />
      </HeaderIcon>
      <Label title={label}>{label}</Label>
    </Header>
    <IllustrationArea aria-hidden="true">
      <Preview data-testid="ai-story-preview">
        <PreviewImage
          src="/ai-story-creation-card/preview.svg"
          alt=""
          data-testid="ai-story-preview-image"
        />
        <PreviewSparkle
          src="/ai-story-creation-card/preview-sparkle.svg"
          alt=""
          data-testid="ai-story-preview-sparkle"
        />
      </Preview>
    </IllustrationArea>
  </Card>
);

export default AiStoryCreationCard;
